export default __webpack_public_path__ + "static/media/header.b49207a7.png";